export default (query, uri, currentType) => {
   let typeQueryVar = '';
   switch (currentType) {
      case 'articles' : typeQueryVar = 'articleTypeList'; break;
      case 'videos' : typeQueryVar = 'videoTypeList'; break;
      case 'podcasts' : typeQueryVar = 'podcastTypeList'; break;
      default : typeQueryVar = ''; break;
   }
   const typeQuery = typeQueryVar?.length > 0 ? `
      ${typeQueryVar} {
           nodes {
             name
           }
         }
   ` : '';
   return `{
   ${query}(id: "${uri}", idType: URI) {
          databaseId
          title
          link
          slug
          uri
          ${typeQuery}
          SeoMetadata {
            metaTitle
            metaDescription
          }
          ${currentType !== 'self-learning' ? `
            productLegacyList {
              nodes {
                name
              }
            }
          ` : ''}
        }
    } `;
};
